
// ROUTES
require('modules/agenda/routes/agenda');

// CONTROLLERS
require('modules/agenda/controllers/agenda');
require('modules/agenda/controllers/list');
require('modules/agenda/controllers/customize');

// SERVICES
require('modules/agenda/services/agenda');


angular.module('unica_agenda', [

	// ROUTES
	'unica_agenda.agenda_routes',

	// CONTROLLERS
	'unica_agenda.agenda_controllers',

	// SERVICES
	'unica_agenda.agenda_services'

]);